import { render, staticRenderFns } from "./orderReports.vue?vue&type=template&id=55993636&scoped=true&"
import script from "./orderReports.vue?vue&type=script&lang=js&"
export * from "./orderReports.vue?vue&type=script&lang=js&"
import style0 from "./orderReports.vue?vue&type=style&index=0&id=55993636&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55993636",
  null
  
)

export default component.exports